import gql from 'graphql-tag';

/**
 * Query to fetch inspection templates for a building.
 * Returns full template data including sections and items.
 */
export const getInspectionTemplatesQuery = gql`
  query getInspectionTemplates(
    $buildingId: SourceEntityIdentifierInput!
    $includeHidden: Boolean
  ) {
    inspectionTemplates(buildingId: $buildingId, includeHidden: $includeHidden) {
      id
      schemaVersion
      version
      parentTemplateId
      locked
      parentTemplateLockedVersion
      hidden
      metadata {
        name
        description
        templateType
        assetTypes
        tags
        buildingId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      config {
        requirePhotoOnDeficiency
        maxPhotosPerItem
        requireNoteOnDeficiency
        defaultQuestionType
        allowObservationItems
        completionRules {
          allItemsRequired
          allowPartialSubmission
        }
      }
      sections {
        id
        name
        description
        order
        origin
        config {
          requirePhotoOnDeficiency
          skippable
          collapsedByDefault
        }
        items {
          id
          label
          helpText
          order
          origin
          questionType
          questionConfig
          required
          photosEnabled
          notesEnabled
          config {
            requirePhotoOnDeficiency
            requireNoteOnDeficiency
            minPhotos
            isComplianceItem
            tags
            category
          }
        }
      }
    }
  }
`;
